import * as types from '../../../../types/masters/stoneAttribute/sieveSize/sieveSizeTypes';
import * as api from '../../../../../api/masters/stoneAttribute/sieveSize/sieveSizeApi';

export const fetchSieveSizes = () => async (dispatch) => {
  dispatch({ type: types.FETCH_SIEVE_SIZE_REQUEST });
  try {
    const data = await api.fetchSieveSizes();
    dispatch({ type: types.FETCH_SIEVE_SIZE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_SIEVE_SIZE_FAILURE, payload: error.message });
  }
};

export const addSieveSize = (sieveSize) => async (dispatch) => {
  try {
    const res = await api.addSieveSize(sieveSize);
    dispatch({ type: types.ADD_SIEVE_SIZE_SUCCESS, payload: res });
    dispatch(fetchSieveSizes());
  } catch (error) {
    dispatch({ type: types.SIEVE_SIZE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateSieveSize = (id, sieveSize) => async (dispatch) => {
  try {
    const res = await api.updateSieveSize(id, sieveSize);
    dispatch({ type: types.UPDATE_SIEVE_SIZE_SUCCESS, payload: res });
    dispatch(fetchSieveSizes());
  } catch (error) {
    dispatch({ type: types.SIEVE_SIZE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteSieveSize = (id) => async (dispatch) => {
  try {
    await api.deleteSieveSize(id);
    dispatch({ type: types.DELETE_SIEVE_SIZE_SUCCESS, payload: id });
    dispatch(fetchSieveSizes());
  } catch (error) {
    dispatch({ type: types.SIEVE_SIZE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setSieveSizeEdit = (sieveSize) => ({
  type: types.SET_SIEVE_SIZE_EDIT,
  payload: sieveSize,
});

export const clearSieveSizeEdit = () => ({
  type: types.CLEAR_SIEVE_SIZE_EDIT,
}); 